import type { SignInOutput } from 'korint-sdk/react';

type SignInNextStep = SignInOutput['nextStep'];

export type MfaType = 'TOTP' | 'SMS';

export type Challenge =
  | { step: 'totp-code'; email: string }
  | { step: 'sms-code'; email: string; destination?: string }
  | { step: 'mfa-selection'; email: string; allowedMfaTypes: MfaType[] };

// EMAIL is never configured on any pool; drop it if Cognito still reports it as allowed.
function toAllowedMfaTypes(allowedMFATypes: string[] | undefined): MfaType[] {
  const allowed = (allowedMFATypes ?? ['TOTP', 'SMS']).filter(
    (type): type is MfaType => type === 'TOTP' || type === 'SMS',
  );
  return allowed.length > 0 ? allowed : ['TOTP', 'SMS'];
}

export function resolveSignInChallenge(nextStep: SignInNextStep, email: string): Challenge | null {
  switch (nextStep.signInStep) {
    case 'CONFIRM_SIGN_IN_WITH_TOTP_CODE':
      return { step: 'totp-code', email };
    case 'CONFIRM_SIGN_IN_WITH_SMS_CODE':
      return { step: 'sms-code', email, destination: nextStep.codeDeliveryDetails?.destination };
    case 'CONTINUE_SIGN_IN_WITH_MFA_SELECTION':
      return {
        step: 'mfa-selection',
        email,
        allowedMfaTypes: toAllowedMfaTypes(nextStep.allowedMFATypes),
      };
    default:
      return null;
  }
}
